import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Button, CircularProgress, Grid } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ApiKeyTable from '../../../components/Super-Admin/integrations/ApiKeyTable';
import ApiKeyForm from '../../../components/Super-Admin/integrations/ApiKeyForm';
import { getApiKeys, createApiKey, revokeApiKey } from '../../../services/integrationService';

export default function ApiManagementPage() {
  const { t } = useTranslation();
  const [keys, setKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formOpen, setFormOpen] = useState(false);

  useEffect(() => {
    fetchApiKeys();
  }, []);

  const fetchApiKeys = async () => {
    setLoading(true);
    try {
      const response = await getApiKeys();
      setKeys(response.data);
    } catch (error) {
      console.error('Failed to fetch API keys:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateKey = async (keyData) => {
    try {
      await createApiKey(keyData);
      fetchApiKeys();
      setFormOpen(false);
    } catch (error) {
      console.error('Failed to create API key:', error);
    }
  };

  const handleRevokeKey = async (keyId) => {
    try {
      await revokeApiKey(keyId);
      fetchApiKeys();
    } catch (error) {
      console.error('Failed to revoke API key:', error);
    }
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 4 } }}>
      <Grid container justifyContent="space-between" alignItems="center" mb={4}>
        <Grid item>
          <Typography variant="h4" gutterBottom>
            {t('apiManagement.title', 'API Key Management')}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {t('apiManagement.subtitle', 'Manage and generate API keys for system integrations')}
          </Typography>
        </Grid>
        <Grid item>
          <Button 
            variant="contained" 
            startIcon={<AddIcon />}
            onClick={() => setFormOpen(true)}
          >
            {t('apiManagement.generateKey', 'Generate New Key')}
          </Button>
        </Grid>
      </Grid>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <ApiKeyTable 
          apiKeys={keys} 
          onRevoke={handleRevokeKey} 
        />
      )}

      <ApiKeyForm 
        open={formOpen} 
        onClose={() => setFormOpen(false)}
        onSubmit={handleCreateKey}
      />
    </Box>
  );
}